import React from 'react'
import { Typography, Button, Tag, Popconfirm, Badge } from 'antd'
import { CloseCircleOutlined, CheckCircleOutlined, InfoCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import moment from 'moment';
import { Link } from 'react-router-dom';
import { IsStormvloed } from '@utils';
import { sortByDate, sortByString } from '../../../utils/functions/Sorters';

const { Text } = Typography;

export default function characterAdminColumns(
    characterTypes,
    characterStatusses, 
    onRowClick,
    onAddSkillPoint,
    unReadComments,
    appState
) {

    const columns = [
      characterIdColumn(appState),
      {
          title: 'Person',
          key: 'larperId',
          render: (record) => {
              return (<Text>
                {record.larper?.name}
              </Text>)
            },
            sorter: (a, b) => sortByString(a.larper?.name, b.larper?.name),
            sortDirections: ['ascend', 'descend', 'ascend'],
      },
        {
            title: 'Character name',
            dataIndex: 'name',
            key: 'name',
            render: (name, record) => {
              return (<Link to={`/${appState.appName}/character?id=${record.id}`}>{name}</Link> )
            },
            sorter: (a, b) => sortByString(a.name, b.name),
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        characterTypesColumn(characterTypes),
        {
            title: 'Short description',
            dataIndex: 'shortDescription',
            key: 'name',
        },
        characterStatusColumn(characterStatusses),
        {
          title: 'Points from events',
          dataIndex: 'eventSkillPoints',
          key: 'eventSkillPoints',
          sorter: (a, b) => a.eventSkillPoints - b.eventSkillPoints,
          sortDirections: ['ascend', 'descend', 'ascend'],
      },
        {
          title: 'Updates / Last updated',
          dataIndex: 'lastUpdated',
          key: 'lastUpdated',
          render: (date, record) => {
            const found = unReadComments?.find(_ => _.characterId === record.id)
             return (
              <>
                {found && <>
                  <Badge status="processing" text={`Unread comments ${found.unseenAmount}`} /> 
                  <br /> 
                </>}
                <Text>
                  {moment(date).format('DD-MM-YYYY HH:mm')}
                </Text>
             </>
             )
           },
           sorter: (a, b) => sortByDate(a.lastUpdated, b.lastUpdated),
           sortDirections: ['ascend', 'descend', 'ascend'],
        },
        {
          title: 'Action',
          key: 'action', 
          render: (record) => {
            return(
              <div>
                {/* <Button onClick={() => onRowClick(record)}>Edit</Button> */}
                <Button onClick={() => onAddSkillPoint(record)}>Add Skillpoint</Button>
              </div>
          )
          }
        }
    ]

    return columns;
}

export function charactersColumn(
    characterTypes,
    races,
    onRowClick,
    onDelete,
    appState,
    unReadComments
    ) {
    
      const isStormvloed = IsStormvloed(appState.storyName)
      const raceArrays = races?.map(_ => {
        return {
          text: _.name,
          value: _.id
        }
      })

      const columns = [
        characterIdColumn(appState),
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => sortByString(a.name, b.name),
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        characterTypesColumn(characterTypes),
        {
            title: 'Short description',
            dataIndex: 'shortDescription',
            key: 'name',
        },
        {
            title: isStormvloed ? 'Race' : 'World',
            key: 'race',
            render: (record) => {
                return (<Text>
                  {record.race?.name}
                </Text>)
              },
            filters: raceArrays,
            onFilter: (value, record) => record.race?.id === value, 
        },
        characterStatusColumn(),
        {
          title: 'Updates / Last updated',
          dataIndex: 'lastUpdated',
          key: 'lastUpdated',
          render: (date, record) => {
            const found = unReadComments.find(_ => _.characterId === record.id)
             return (
              <>
                {found && <>
                  <Badge status="processing" text={`Unread comments ${found.unseenAmount}`} /> 
                  <br /> 
                </>}
                <Text>
                  {moment(date).format('DD-MM-YYYY HH:mm')}
                </Text>
             </>
             )
           },
           sorter: (a, b) => sortByDate(a.lastUpdated, b.lastUpdated),
           sortDirections: ['ascend', 'descend', 'ascend'],
        },
        {
          title: 'Action',
          key: 'action', 
          render: (record) => {
            return(
              <div>
                <Button onClick={() => onRowClick(record)}>Edit</Button>
                <Popconfirm title="Sure to delete?" onConfirm={() => onDelete(record)}>
                {/*eslint-disable-next-line*/}
                    <a>  Delete</a>
                </Popconfirm>

              </div>
          )
          }
        }
    ]

    return columns
}

function characterIdColumn(appState) {
  return {
    title: 'Id',
    dataIndex: 'id',
    key: 'id',
    render: (id) => {
        return (<Link to={`/${appState.appName}/character?id=${id}`}>{id}</Link> )
      },
      sorter: (a, b) => a.id - b.id,
      sortDirections: ['ascend', 'descend', 'ascend'],
  }
}

function characterTypesColumn(characterTypes) {

    const characterTypesArray = characterTypes?.map(_ => {
        return {
          text: _.name,
          value: _.id
        }
      })

    return {
        title: 'Type',
        key: 'type',
        render: (record) => {
            return (<Text>
              {record.characterType?.name}
            </Text>)
          },
        filters: characterTypesArray,
        onFilter: (value, record) => record.characterType?.id === value, 
    }
}

function characterStatusColumn(characterStatusses) {
    const characterStatussesArray = characterStatusses?.map(_ => {
        return {
          text: _.name,
          value: _.id
        }
      })

    return {
            
        title: 'Status',
        key: 'status',
        render: (record) => {


            switch(record.characterStatus?.name) {
              case "Dead":
                return (
                  <Tag color="purple">
                      {record.characterStatus?.name}
                  </Tag>
                )
                case "Rejected":
                  return (
                    <Tag icon={<CloseCircleOutlined />} color="error">
                        {record.characterStatus?.name}
                    </Tag>
                  )
                case "Accepted by SL":
                  return (
                    <Tag icon={<CheckCircleOutlined />} color="success">
                        {record.characterStatus?.name}
                    </Tag>
                  )
                case "Review for SL":
                  return (
                    <Tag icon={<ExclamationCircleOutlined />} color="warning">
                        {record.characterStatus?.name}
                    </Tag>
                  )
                case "Changed after Accepted":
                    return (
                        <Tag icon={<InfoCircleOutlined />} color="default">
                            {record.characterStatus?.name}
                        </Tag>
                    )
                default:
                  return null;
            }
          },
        filters: characterStatussesArray,
        onFilter: (value, record) => record.characterStatus?.id === value, 
    }
}